import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface RegraPagamento {
  id?: string;
  // Adicione os campos necessários conforme o modelo real
}

@Injectable({
  providedIn: 'root',
})
export class RegraPagamentoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all RegraPagamento
  list(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: RegraPagamento[] }>(
        `${this.path}/RegraPagamento`,
        params ? new HttpParams({ fromObject: params }) : this.params
      )
      .pipe(map((response) => response));
  }

  // Get RegraPagamento by ID
  public show(id: string): Observable<any> {
    return this.apiService
      .get<{ object: RegraPagamento }>(`${this.path}/RegraPagamento/${id}`)
      .pipe(map((response) => response));
  }

  // Create new RegraPagamento
  public store(regraPagamento: RegraPagamento): Observable<any> {
    return this.apiService
      .post<{ object: RegraPagamento }>(
        `${this.path}/RegraPagamento`,
        regraPagamento
      )
      .pipe(map((response) => response));
  }

  // Create many RegraPagamento (range)
  public storeRange(regras: RegraPagamento[]): Observable<any> {
    return this.apiService
      .post<{ data: RegraPagamento[] }>(
        `${this.path}/RegraPagamento/range`,
        regras
      )
      .pipe(map((response) => response));
  }

  // Update existing RegraPagamento
  public update(regraPagamento: RegraPagamento): Observable<any> {
    return this.apiService
      .put<{ object: RegraPagamento }>(
        `${this.path}/RegraPagamento`,
        regraPagamento
      )
      .pipe(map((response) => response));
  }

  // Delete existing RegraPagamento
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/RegraPagamento/${id}`);
  }
}
